const _ = require('lodash');

const doc = document.documentElement;
let prevScroll = window.scrollY || doc.scrollTop;
let curScroll;
let direction = 0;
let prevDirection = 0;

const header = document.querySelector('.site-header');

function headerScroll() {
    
    if (window.scrollY < 70) {
        header.classList.remove('animateIn');    
    }

    curScroll = window.scrollY || doc.scrollTop;
    
    if (curScroll > prevScroll) { 
      //scrolled up
      direction = 2;
    } else if (curScroll < prevScroll) { 
      //scrolled down
      direction = 1;
    }
    
    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    prevScroll = curScroll;
}

function toggleHeader(direction, curScroll) {
    
    if (direction === 2 && curScroll > 70) { 
        header.classList.add('animateOut');
        header.classList.remove('animateIn');
        prevDirection = direction;     
    } else if (direction === 1) {
        header.classList.remove('animateOut');
        header.classList.add('animateIn');
        prevDirection = direction;   
    } 
        
}

window.addEventListener('scroll', _.throttle(headerScroll, 50), false);
